export default __webpack_public_path__ + "static/media/russia.76472077.svg";